class MrMegaTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.mr-tab'));
    this.panes = Array.from(this.querySelectorAll('.mr-mega__pane'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.tab));
      tab.addEventListener('mouseenter', () => this.activate(tab.dataset.tab));
    });
  }

  activate(id) {
    this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.tab === id));
    this.panes.forEach((pane) => pane.classList.toggle('is-active', pane.dataset.tab === id));
  }
}
customElements.define('mr-mega-tabs', MrMegaTabs);

function setupMrMega() {
  const megas = Array.from(document.querySelectorAll('details.mr-mega'));
  if (!megas.length) return;

  const syncScrollLock = () => {
    document.body.style.overflow = megas.some((d) => d.open) ? 'hidden' : '';
  };

  megas.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.open) {
        megas.forEach((other) => {
          if (other !== details) other.open = false;
        });
      }
      syncScrollLock();
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    megas.forEach((d) => (d.open = false));
    syncScrollLock();
  });
}

if (document.readyState !== 'loading') setupMrMega();
else document.addEventListener('DOMContentLoaded', setupMrMega);

class MrDrawer extends HTMLElement {
  connectedCallback() {
    this.panel = this.querySelector('.mr-drawer__panel');
    this.root = this.querySelector('.mr-drawer__view--root');
    this.toggle = this.querySelector('.mr-drawer__toggle');

    this.toggle.addEventListener('click', () => this.open());
    this.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-mr-open]');
      const back = event.target.closest('[data-mr-back]');
      const closer = event.target.closest('[data-mr-close]');

      if (opener) this.showView(opener.getAttribute('data-mr-open'));
      else if (back) this.resetViews();
      else if (closer) this.close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.classList.contains('is-open')) this.close();
    });
  }

  open() {
    this.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(() => this.resetViews(), 250);
  }

  showView(id) {
    const view = this.querySelector(`#${id}`);
    if (!view) return;
    view.classList.add('is-active');
    if (this.root) this.root.classList.add('is-shifted');
  }

  resetViews() {
    this.querySelectorAll('.mr-drawer__view.is-active').forEach((view) => view.classList.remove('is-active'));
    if (this.root) this.root.classList.remove('is-shifted');
  }
}
customElements.define('mr-drawer', MrDrawer);
